import { render, staticRenderFns } from "./SeverityChart.vue?vue&type=template&id=578908b5"
import script from "./SeverityChart.vue?vue&type=script&lang=ts"
export * from "./SeverityChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578908b5')) {
      api.createRecord('578908b5', component.options)
    } else {
      api.reload('578908b5', component.options)
    }
    module.hot.accept("./SeverityChart.vue?vue&type=template&id=578908b5", function () {
      api.rerender('578908b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/SeverityChart.vue"
export default component.exports